import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type { GetExecutionStatusResponse } from '@eggplant/types'

interface Props {
  id: string
  interval?: number
  isPolling: boolean
  onSuccess: (response: GetExecutionStatusResponse) => void
}

const PollAiExecutionRequest = ({
  id,
  interval = 1000,
  isPolling,
  onSuccess
}: Props) => {
  const url = `${AI_API_SERVICE}/executions/${id}`

  return (
    <AuthenticatedPolling<GetExecutionStatusResponse>
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiExecutionRequest
